import * as z from "zod/v4";

export const updateTicketSubmitterName = {
  name: "updateTicketSubmitterName" as const,
  input: z.object({ linearTicketId: z.string(), submitterName: z.string() }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
